/**
 * Component: Video Intersection script
 * ------------------------------------------------------------------------------
 * Handles loading video elements using IntersectionObserver.
 *
 */

import { setIntersectionObserver } from "~/helpers/general"

/**
 * DOM selectors.
 */
const selectors = {
  video: '[js-video-intersection="video"]',
}

/**
 * Create a new video intersection object.
 */
export default () => {

  /**
   * DOM node selectors.
   */
  const nodeSelectors = {
    videos: [...document.querySelectorAll(selectors.video)],
  }

  const isReducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches

  /**
   * Initialise component.
   */
  function init() {
    if (isReducedMotion) {
      return
    }

    setVideoIntersection()
  }

  /**
   * Set intersection observers.
   */
  function setVideoIntersection() {
    nodeSelectors.videos.forEach((video) => {
      setIntersectionObserver({
        callback: handleVideoIntersection,
        element: video,
        threshold: 0.1,
      })
    })
  }

  /**
   * Handle video intersection.
   * - If the video is intersecting, then play the video.
   * - Allows for autoplay-like behavior but only when a video is visible,
   *   saving on user bandwidth.
   * @type {IntersectionObserverCallback}
   */
  function handleVideoIntersection(entries, observer) {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) {
        return
      }

      const video = entry.target
      if (video.paused) {
        video.play()
      }

      observer.unobserve(entry.target)
    })
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init,
  })
}
